import React from 'react';
import {NAVIGATION_ITEMS} from './Navigation';
import NavTabs from './NavTabs';
import {GenerateMockInvitations} from './GenerateMockInvitations';

export function MeetingTabs() {
  return (
    <>
      <NavTabs
        tabs={[
          {
            href: NAVIGATION_ITEMS.DASHBOARD.link,
            icon: NAVIGATION_ITEMS.DASHBOARD.icon,
            label: NAVIGATION_ITEMS.DASHBOARD.label,
          },
          {
            href: NAVIGATION_ITEMS.INVITES.link,
            icon: NAVIGATION_ITEMS.INVITES.icon,
            label: NAVIGATION_ITEMS.INVITES.label,
          },
          {
            href: NAVIGATION_ITEMS.INVITED.link,
            icon: NAVIGATION_ITEMS.INVITED.icon,
            label: NAVIGATION_ITEMS.INVITED.label,
          },
          {
            href: NAVIGATION_ITEMS.SCHEDULED.link,
            icon: NAVIGATION_ITEMS.SCHEDULED.icon,
            label: NAVIGATION_ITEMS.SCHEDULED.label,
          },
          {
            href: NAVIGATION_ITEMS.COMPLETED.link,
            icon: NAVIGATION_ITEMS.COMPLETED.icon,
            label: NAVIGATION_ITEMS.COMPLETED.label,
          },
          {
            href: NAVIGATION_ITEMS.DECLINED.link,
            icon: NAVIGATION_ITEMS.DECLINED.icon,
            label: NAVIGATION_ITEMS.DECLINED.label,
          },
          {
            href: NAVIGATION_ITEMS.UNCONTACTABLE.link,
            icon: NAVIGATION_ITEMS.UNCONTACTABLE.icon,
            label: NAVIGATION_ITEMS.UNCONTACTABLE.label,
          },
        ]}
        rightTabs={[
          {
            href: NAVIGATION_ITEMS.TODAY.link,
            icon: NAVIGATION_ITEMS.TODAY.icon,
            label: NAVIGATION_ITEMS.TODAY.label,
          },
        ]}
      >
        <GenerateMockInvitations />
      </NavTabs>
    </>
  );
}
